export default __webpack_public_path__ + "static/media/Linear-bg-landing.9d60113c.svg";